import React from 'react';
import styled from 'styled-components';
import { layout, colors } from 'Constants';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function getSize(size) {
  if (size === '4x') return '96px';
  if (size === '2x') return '48px';
  else return '36px';
}

function getFontSize(size) {
  if (size === '4x') return '2em';
  if (size === '2x') return '1.5em';
  else return '1em';
}

const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => (props.background ? props.background :'#081f65')};
  width: ${props => getSize(props.size)};
  height: ${props => getSize(props.size)};
  color: ${props => (props.color ? props.color : colors.textOnAccent)};
  align-self: center !important;
  font-size: ${props => props.size === '2x' && !props.isIcon ? '2em' : '1em'}
`;

export default class NavBar extends React.Component {
  render() {
    let child = this.props.children;
    if (this.props.icon)
      child = <FontAwesomeIcon icon={this.props.icon} size={this.props.size} />;
    return (
      <Icon
        color={this.props.color}
        background={this.props.background}
        size={this.props.size}
        isIcon={!!this.props.icon}
      >
        {child}
      </Icon>
    );
  }
}
